module.exports = {
	development: 'https://staging.mylearningmyway.com/wp-content/plugins/terabit-matrix-game/assets/audio',
	production: '/wp-content/plugins/terabit-matrix-game/assets/audio'
};